import { CellRendererParams } from './CellRendererParams'
import { CircularProgress, Theme, makeStyles } from '@forgeglobal/design-framework'
import React from 'react'

const useStyles = makeStyles((theme: Theme) => ({
  loading: {
    margin: 'calc((48px - 20px) / 2) 24px', // The height of the cell is 48px, that of the loading indicator is 20px
  },
}))

export const LoadingRenderer = (params: CellRendererParams<string>) => {
  const styles = useStyles()
  return (
    <CircularProgress size={20} thickness={4} color="secondary" className={styles.loading} data-cy="tableLoadingRow" />
  )
}
